import "./index.css";
import React, { useState } from "react";
// import { EditOutlined } from "@ant-design/icons";   
import CropperModal from "../../Photo/CropperModal";

import ICON_AVATAR from "../assets/avatar.svg";

interface TypeUploadAvatarProps<T = string> {
  /**
   * @param value 图片base64
   */
  value?: T;
  /**
   * @name onChange 拿到图片的base
   */
  onChange?(value?: T): void;
}

/**
 * @name UploadAvatar 上传头像
 */
const UploadAvatar: React.FC<TypeUploadAvatarProps> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);

  function onCreateUpload(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    const ele = document.createElement("input");
    ele.setAttribute("type", "file");
    ele.setAttribute("accept", "image/*");
    ele.style.display = "none";
    document.body.appendChild(ele);
    ele.onchange = (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      document.body.removeChild(ele);
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        alert('Image size must be less than 5MB');
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => onChange?.(e.target?.result as string);
      reader.readAsDataURL(file);
      setOpen(true);
    };
    ele.click();
  }

  function onEditSave(val: string) {
    onChange?.(val);
  }

  function onEditOpen() {
    setOpen((b) => !b);
  }

  return (
    <div className="website-upload">
      <div
        className={`website-upload-icon ${value ? "website-upload-edit" : ""}`}
      >
        <img
          alt="#"
          src={value || ICON_AVATAR}
          className={`website-upload-${value ? "user" : "default"}`}
        />
        {/* {value ? <EditOutlined rev={undefined} /> : null} */}
      </div>
      <div className="website-upload-func">
        <button onClick={onCreateUpload}>Upload image</button>
        <p>Profiles with photos get 21x more views</p>
      </div>

      <CropperModal
        type="circle"
        visible={open}
        aspectRatio={1}
        imageSrc={value}
        onClose={onEditOpen}
        onSave={onEditSave}
      />
    </div>
  );
};

export default UploadAvatar;
